import React from 'react';

const Signin = React.lazy(() => import('../../modules/auth/Signin'));
const Signup = React.lazy(() => import('../../modules/auth/Signup'));
const ForgotPassword = React.lazy(() =>
  import('../../modules/auth/ForgetPassword'),
);
const ResetPassword = React.lazy(() =>
  import('../../modules/auth/ResetPassword'),
);
const Invitation = React.lazy(() =>
  import('../../modules/auth/Signup/Invitation'),
);
const ProductWizardPage = React.lazy(() =>
  import('../../modules/ProductWizardPage'),
);
const PackageWidget = React.lazy(() => import('../../modules/PackageWidget'));
const ProductListing = React.lazy(() =>
  import('../../modules/student/Products/ProductListing'),
);
const OrderConfirmation = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Confirmation'),
);
const ActiveTournaments = React.lazy(() =>
  import('../../modules/admin/Tournament/TournamentsListView'),
);

export const authRouteConfig = [
  {
    path: '/signin',
    element: <Signin />,
  },
  {
    path: '/signup',
    element: <Signup />,
  },
  {
    path: '/reset-password',
    element: <ForgotPassword />,
  },
  {
    path: '/reset-password/:token',
    element: <ResetPassword />,
  },
  {
    path: '/invitation/activate/:token',
    element: <Invitation />,
  },
  {
    path: '/product-listing',
    element: <ProductListing />,
  },
  {
    path: '/widgets/products/:productSlug',
    element: <ProductWizardPage isProduct={true} />,
  },
  {
    path: '/widgets/packages/:packageSlug',
    element: <PackageWidget />,
  },
  {
    path: '/widgets/tournament/:tournamentSlug',
    element: <ProductWizardPage isProduct={false} />,
    requiresTournamentAddon: true, // Add this flag
  },
  {
    path: '/order/confirmation/:transId',
    element: <OrderConfirmation isProduct={false} />,
    requiresTournamentAddon: true, // Add this flag
  },
  {
    path: '/tournaments',
    element: <ActiveTournaments />,
    requiresTournamentAddon: true, // Add this flag
  },
];
